var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('banner'),_c('div',{staticClass:"main-body"},[_c('dl',{staticClass:"news-list"},[_c('dt',{staticClass:"title"},[_vm._v("新闻动态")]),_c('dd',{staticClass:"main"},[_c('div',{staticClass:"list"},[_c('el-row',{attrs:{"gutter":_vm.newsListConfig.gutter}},_vm._l((_vm.newsData),function(itm,index){return _c('el-col',{key:index,attrs:{"span":_vm.newsListConfig.pageWidth <= 1003
                  ? _vm.newsListConfig.span
                  : index == 0
                  ? 16
                  : 8}},[_c('news-card',{attrs:{"is-top":(!index && _vm.newsListConfig.pageWidth > 1003) ? true : false,"newsData":itm}})],1)}),1)],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }